export default __webpack_public_path__ + "static/media/syringe_office.28c70327.jpg";